<template>
    <div class="d-flex blog__articles-meta align-items-center">
        <category-badge :category="article.category" />
        <div class="blog__articles-date" v-text="formattingPublishDate"></div>
        <div class="blog__articles-read-time" v-text="readTime"></div>
    </div>
</template>

<script>

import CategoryBadge from './CategoryBadge.vue'

export default {
    name: "ArticleMeta",
    components: { CategoryBadge },

    props: {
        article: {
            required: true,
            type: Object
        }
    },

    computed: {

        readTime() {
            return `На чтение ${this.article.read_time} мин.`
        },

        formattingPublishDate() {
           return (this.article.publish_date.split(' ')[0]).split('-').reverse().join('.')
        },

    }

}

</script>
